import OscarEventPendingAlertHtml from './templates/oscar.event-pending.alert.html';
import OscarRequestEventHtml      from './oscar.request-event.html';

export function OscarEventsService (
  $uibModal, 
  $q, 
  $translate, 
  confirm, 
  sessionObjAPI, 
  workshopAPI
) {
  const OscarEvents = function (event, vehicle) {
    this.origin  = sessionObjAPI.base().origin;
    this.Event   = event;
    this.vehicle = vehicle || {};
  };

  OscarEvents.prototype.addItems = function () {
    const self = this;

    return $q.when().then(() => {
      return self.Event.event.id ? $q.when(self.Event.event) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.EVENT_MUST_FIRST_BE_SAVED', { name: 'Oscar' }), null, 'oscarEventsAutoSave').then(() => {
          return self.Event.save();
        });
    }).then(event => {
      if (event.current_oscar_order) {
        return self.checkOscarAvailability(event).then(() => {
          return self.createOscarOrder(event);
        }).catch(() => {
          return self.eventPendingAlert(event);
        });
      }

      return self.createOscarOrder(event);
    });
  };

  OscarEvents.prototype.checkOscarAvailability = function (event) {
    const self = this;

    return workshopAPI.get('/oscar/check_oscar_id_for_event', event.id).then(requestId => {
      return requestId === '0' ? $q.reject($translate.instant('JS_SPACE.OSCAR.ORDER_NOT_COMPLETED')) : $q.when(event);
    });
  };

  OscarEvents.prototype.createOscarOrder = function (event) {
    const self = this;

    return workshopAPI.get('/oscar/create_oscar_order_for_event', event.id).then(data => {
      return data.order.RequestStatus != 'FAIL' ?
        workshopAPI.get('/oscar/add_oscar_request_id_to_event', [ data.order.RequestID, event.id ]) :
          $q.reject(data.order.RequestStatus + " - " + data.order.ErrorReason);
    }).then(event => {
      return $uibModal.open({
        templateUrl: OscarRequestEventHtml,
        controller : 'OscarRequestEventCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          event () {
            return event;
          },
          customer () {
            return workshopAPI.get('/customer', event.customer_id)
          }
        }
      }).result;
    })
  };

  OscarEvents.prototype.getOscarItems = function (event) {
    const self = this;

    return self.checkOscarAvailability(event).then(event => {
      return workshopAPI.get('/oscar/get_single_oscar_order_for_event', [event.current_oscar_order, event.id]);
    }).then(items => {
      return workshopAPI.post('/oscar/add_oscar_items_to_event', items, 'items');
    }).then(data => {
      return workshopAPI.get('/oscar/remove_oscar_request_id_from_event', data);
    }).then(() => {
      return $q.when($translate.instant('JS_SPACE.OSCAR.OSCAR_PARTS_ADDED'));
    });
  };

  OscarEvents.prototype.eventPendingAlert = function (event) {
    const self = this;

    return $uibModal.open({
      templateUrl: OscarEventPendingAlertHtml,
      controller : 'OscarRequestEventCtrl',
      windowClass: 'lg-modal',
      resolve    : {
        event () {
          return event;
        },
        customer () {
          return workshopAPI.get('/customer', event.customer_id)
        }
      }
    }).result;
  };

  OscarEvents.prototype.overwrite = function (event) {
    const self = this;

    return workshopAPI.get('/oscar/remove_oscar_request_id_from_event', event.id).then(data => {
      return workshopAPI.get('/oscar/create_oscar_order_for_event', data.id);
    }).then(data => {
      return workshopAPI.get('/oscar/add_oscar_request_id_to_event', [ data.order.RequestID, event.id ]);
    }).then(event => {
      return $uibModal.open({
        templateUrl: OscarRequestEventHtml,
        controller : 'OscarRequestEventCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          event () {
            return event;
          },
          customer () {
            return workshopAPI.get('/customer', event.customer_id);
          }
        }
      }).result;
    });
  };

  return OscarEvents;
}
